import React from "react";
import logo from "../../Assets/Images/lbc_app.png";

const Logo = (props) => {
  return <img alt="Logo" src={logo} {...props} style={{ maxHeight: 50 }} />;
};

export default Logo;
